/**
 * 
 * @copyright     (c) 2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/pages/GiftCardForm/_themes/CrispTheme.tsx
 * Created:       Wed Apr 16 2025
 * Modified By:   Greg Olive
 * Last Modified: Tue Nov 04 2025
 */

import React, { useContext } from 'react';
import { FormContext } from "@proxy/_contexts";
import {
  SendMultipleButton,
  SendSingleButton,
} from "@proxy/_components";
import {
  ContentBottom,
  ContentTop,
  FormElement,
} from "../_sections";

type CrispThemeProps = {
  previewData: any;
  bulkTranslations: any;
  togglePreview: () => void;
};

const CrispTheme = ({
  previewData,
  bulkTranslations,
  togglePreview,
}: CrispThemeProps) => {

  const {
    loading,
    bulkOrder,
  } = useContext(FormContext);

  return ((!loading) ?
    <div className="gc__layout_wrapper">
      {(bulkOrder === false) ?
        <div className="gc__selected-card-image-wrapper">
          <img
            className="gc__selected-card-image"
            src={previewData.selected_card_image}
            alt="Selected Gift Card image"
          />
        </div>
      : null}

      <div className={`gc__giftcard-main ${(bulkOrder) ? "gc__giftcard-main--bulk" : ""}`}>
        <ContentTop />
        <div className="gc__bulk-button-container">
          {(bulkOrder === true)
            ? <SendSingleButton bulkTranslations={bulkTranslations} />
            : <SendMultipleButton bulkTranslations={bulkTranslations} />
          }
        </div>
        <FormElement
          togglePreview={togglePreview}
        />
        <ContentBottom />
      </div>
    </div>
  : null);
};

export default CrispTheme;
